import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroCarousel from "./components/HeroCarousel";
import QuickBooking from "./components/QuickBooking";
import PortfolioShowcase from "./components/PortfolioShowcase";
import ExclusivePromotions from "./components/ExclusivePromotions";
import ClientTestimonials from "./components/ClientTestimonials";
import AboutUs from "./components/AboutUs";
import JournalBlog from "./components/JournalBlog";
import ShopSection from "./components/ShopSection";
import MeetStylists from "./components/MeetStylists";
import ServicesSection from "./components/ServicesSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroCarousel />
        <ServicesSection />
        <QuickBooking />
        <PortfolioShowcase />
        <ExclusivePromotions />
        <ClientTestimonials />
        <AboutUs />
        <MeetStylists />
        <JournalBlog />
        <ShopSection />
      </main>
      <Footer />
    </div>
  );
}
